import { render } from "./ChannelGoalBegin.vue?vue&type=template&id=79beeaa7"
import script from "./ChannelGoalBegin.vue?vue&type=script&lang=ts"
export * from "./ChannelGoalBegin.vue?vue&type=script&lang=ts"
script.render = render

export default script